<script lang="ts" module>
	export enum VoiceSampleButtonType {
		SMALL = 'small',
		LARGE = 'large'
	}
</script>

<script lang="ts">
	import { getSafeSrc } from '@repo/commons/utils'
	import { Button, ButtonType, ButtonSize } from '@repo/commons/components'

	interface Props {
		voiceSample: string
		voiceSampleButtonType?: VoiceSampleButtonType
		buttonText?: string | null
	}

	let {
		voiceSample,
		voiceSampleButtonType = VoiceSampleButtonType.SMALL,
		buttonText = null
	}: Props = $props()

	let isPlaying: boolean = $state(false)
	let currentAudio: HTMLAudioElement | null = null

	const toggleAudio: () => void = (): void => {
		if (!voiceSample) return
		// If audio is already playing, stop it.
		if (isPlaying && currentAudio) {
			currentAudio.pause()
			currentAudio.currentTime = 0
			isPlaying = false
			currentAudio = null
		} else {
			const audioSrc: string = getSafeSrc(voiceSample, 'audio') ?? ''
			currentAudio = new Audio(audioSrc)
			currentAudio
				.play()
				.then((): void => {
					isPlaying = true
				})
				.catch((err: Error): void => {
					console.error('Error playing voice sample:', err)
				})
			// When the audio finishes, reset the state.
			currentAudio.addEventListener('ended', (): void => {
				isPlaying = false
				currentAudio = null
			})
		}
	}
</script>

<Button
	buttonType={ButtonType.INVERSE_OUTLINE}
	buttonSize={voiceSampleButtonType === VoiceSampleButtonType.LARGE
		? ButtonSize.SMALL
		: ButtonSize.EXTRA_SMALL}
	buttonText={buttonText ?? ''}
	iconProps={{ name: isPlaying ? 'stopAudio' : 'playAudio', size: 'sm', class: 'text-[#007ACCCC]' }}
	onclick={toggleAudio}
/>

<style lang="postcss">
</style>
